export const createDaysInMonth = (month: number, year: number) => {
  const days = new Date(year, month, 0).getDate();
  return Array.from({ length: days }, (_, index) => {
    const day = index + 1;
    return { value: String(day), label: String(day) };
  });
};
